'use strict';

/* eslint-disable */
angular.module('webAgro1App').controller('RelatorioVisitaCustomizadoCtrl', function($rootScope, $scope, $q, filterFilter, Flash, $location,
  LoadingService, OperacoesService, OperacoesDadosService, RelatorioVisitaCustomizadoService, MessagesService, RelatorioVisitaService,
  HistoricosService, ckeditorconfig, RecomendacoesService, ResumoOcorrenciasIndicadoresService, $interpolate, $uibModal,
  $routeParams, CommonHTTPService, RotateImageService, SemeaduraAfericaoService, ColheitaAfericaoService, MapasInfestacaoService) {
  const error = function(error) {
    if (error) {
      console.error(error);
    }
    MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
    LoadingService.hideLoading();
  };

  const tiposPermitidos = ['anotacao', 'climatica', 'solo', 'manutencao_melhoria'].concat(TIPOS_OPERACAO_OCORRENCIAS);

  $scope.toggleDisableImage = function(imagem) {
    imagem.disabled = !imagem.disabled;
  };

  $scope.filters = {
    data: null,
    usuarios: [],
  };

  $scope.gerando = false;

  const verifyJobProgress = (param) => {
    $scope.loadingRelatorio = true;
    const clear = (intervalo) => {
      $scope.gerando = false;
      clearInterval(intervalo);
    };

    const intervalo = setInterval(() => {
      RelatorioVisitaService.download(param).then((response) => {
        const { data } = response;
        const message = JSON.parse(data.message);
        if (data.status === 'complete') {
          $scope.relatorioId = message.id;
          $scope.url = `${SERVER}/${message.url}`;
          $scope.htmlLink = RelatorioVisitaService.generateHtmlLink(message.uuid);
          clear(intervalo);
        }
        if (data.status === 'failed' || data.status === 'interrupted') {
          MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
          clear(intervalo);
        }
      }, function(error) {
        MessagesService.alert('Ocorreu um erro, tente novamente mais tarde.');
        clear(intervalo);
      });
    }, 15000);
  };

  $scope.recomendacoes = [];

  $scope.defaultItem = {
    id: 1,
    descricao: 'Customizado',
    tipo: 'customizado',
    conteudo: '',
    imagens: []
  };
  $scope.dragging = false;
  $scope.resumo_por_cultivar = false;
  $scope.mainSortableOptions = {};
  $scope.discardedSortableOptions = {};
  $scope.sortableRecommendations = {
    handle: '.handle',
    placeholder: 'placeholder'
  };

  // Status possíveis untouched, loading e success
  $scope.statusInfestationMaps = 'untouched';

  function generateMainSortable(gleba) {
    return {
      handle: '.icon-area',
      start: function() {
        $scope.dragging = true;
        $scope.$apply();
      },
      stop: function() {
        $scope.dragging = false;
        $scope.$apply();
      },
      connectWith: `.discarded-${ gleba.id}`,
      placeholder: 'placeholder'
    };
  }
  function generateDiscardedSortable(gleba) {
    return {
      handle: '.icon-area',
      connectWith: `.dados-${ gleba.id}`,
      start: function() {
        $scope.dragging = true;
        $scope.$apply();
      },
      stop: function() {
        $scope.dragging = false;
        $scope.$apply();
      }
    };
  }

  $scope.editorConfig = ckeditorconfig;

  $scope.addCustomContent = function(gleba) {
    gleba.dados.unshift(angular.copy($scope.defaultItem));
  };

  const getIdRegistro = function(item) {
    return `${item.tipo }-${ item.id}`;
  };

  $scope.getDatasGlebas = function(gleba) {
    $scope.datasGlebas = [];
    $scope.showCalendar = false;
    OperacoesService.datas({ tipo: String(tiposPermitidos), gleba: gleba.id }).then(function(datas) {
      $scope.datasGlebas = datas;
    }, error)
      .finally(function() {
        $scope.showCalendar = true;
      });
  };

  $scope.getGlebaDia = function(gleba, initial) {
    const deferred = $q.defer();
    gleba.loading = true;
    const usuarios = $scope.filters.usuarios.map(usuario => (usuario|| {}).id).join(',');
    const filters = {
      gleba: { id: gleba.id },
      dia: moment(gleba.dia).format(MOMENT_DATE_ENGLISH_FORMAT),
      usuario: usuarios,
    };

    OperacoesService.getOperationsDayGleba(filters).then(function(data) {
      const dados = (data.data || []).map(function(item) {
        if (tiposPermitidos.indexOf(item.tipo) >= 0) {
          const idRegistro = getIdRegistro(item);
          const produto = filterFilter(gleba.dados, { idRegistro: idRegistro }, true) || [];
          if (produto.length === 0) {
            item.idRegistro = idRegistro;
            item.objeto = JSON.parse(item.objeto);
            item.situacaoDescricao = (TYPES_STATUS_OPERATIONS[item.situacao] || {}).description || '';

            const date = moment($scope.configInicial.data);
            const date2 = moment(gleba.dia);
            if (!date.isSame(date2, 'day')) {
              item.dataRegistro = gleba.dia;
            }

            RelatorioVisitaCustomizadoService.getConteudoTemplate(item).then(function(data) {
              item.conteudo = data;
            });
            item.imagens = OperacoesDadosService.getImagesObject(item.imagens, true);
            return item;
          }
        } else if (item.tipo === 'semeadura_afericao') {
          item.imagens = OperacoesDadosService.getImagesObject(item.imagens, true);
          gleba.afericoes.push(item);
        }
      }).filter(Boolean);

      if (initial) {
        gleba.dados = gleba.dados && gleba.dados.length ? gleba.dados.concat(dados) : dados;
      } else {
        gleba.dadosDescartados = gleba.dadosDescartados && gleba.dadosDescartados.length ? gleba.dadosDescartados.concat(dados) : dados;
      }

      deferred.resolve();
    }, deferred.reject)
      .finally(function() {
        gleba.loading = false;
      });

    return deferred.promise;
  };

  $scope.getRecomendacoesDia = function() {
    const deferred = $q.defer();
    $scope.loading = true;
    const filters = {
      dataInicial: moment($scope.configInicial.dataRecomendacao).format(MOMENT_DATE_ENGLISH_FORMAT),
    };

    RecomendacoesService.list(filters).then(function(recomendacoes) {
      const selecionadas = _.filter($scope.recomendacoes, { selected: true });
      $scope.recomendacoes = _.uniqBy(selecionadas.concat(recomendacoes.data), 'id');
      deferred.resolve();
    }, deferred.reject)
      .finally(function() {
        $scope.loading = false;
      });

    return deferred.promise;
  };

  $scope.voltar = function() {
    if ($scope.relatorioId) {
      $location.path('/relatorios');
    } else {
      initVariables();
    }
  };

  $scope.gerarRelatorio = function() {
    $scope.url = null;
    $scope.gerando = true;

    let allItens = [];
    $scope.glebas.forEach(function(gleba) {

      allItens = allItens.concat((gleba.dados || []).map(function(dado) {
        let id = dado.id;
        if (dado.tipo === 'customizado' || dado.tipo === 'medias_afericoes') {
          id = gleba.id;
        }
        const ret = {
          id: id,
          tipo: dado.tipo,
          texto: Array.isArray(dado.conteudo) ? dado.conteudo.join('') : dado.conteudo,
          imagens: (dado.imagens || []).filter(function(imagem) {
            return !imagem.disabled;
          }).map(function(imagem) {
            return imagem.editedURL ? imagem.editedURL : imagem.idOriginal;
          })
        };

        if (!ret.imagens) {
          delete ret.imagens;
        }

        return ret;
      }));
    });

    const recomendacoes = ($scope.recomendacoes || []).filter(function(recomendacao) {
      return recomendacao.selected;
    }).map(function(recomendacao) {
      return recomendacao.id;
    });

    let nextVisit = null

    if ($scope.configInicial.incluirProximaVisita) {
      const dataProximaVisita = moment($scope.configInicial.dataProximaVisita)

      if (dataProximaVisita.isValid()) {
        nextVisit = dataProximaVisita.format(MOMENT_DATE_ENGLISH_FORMAT)
      }
    }

    RelatorioVisitaService.gerar({
      id: $scope.relatorioId,
      geral: $scope.configInicial.conteudoGeral,
      data_proxima_visita: nextVisit,
      recomendacoes_outras_datas: recomendacoes,
      incluir_assinaturas: $scope.configInicial.incluirAssinaturas,
      quebrar_atividade: $scope.configInicial.quebrarAtividade,
      quebrar_por_gleba: $scope.configInicial.quebrarPorGleba,
      personalizar_logotipo: $scope.configInicial.personalizarLogotipo,
      logotipo: $scope.configInicial.logotipo,
      resumo_por_cultivar: $scope.resumo_por_cultivar,
      responsavel: $scope.configInicial.responsavel,
      itens: allItens,
      atividades: $scope.atividades.dados,
      glebasForRestore: $scope.glebas,
      recomendacoesForRestore: $scope.recomendacoes,
      atividadesForRestore: $scope.atividades,
      configInicialForRestore: $scope.configInicial,
      usuarios: $scope.configInicial.usuarios
    }).then(function(result) {
      console.log('Gerando Relatório de Visitas - enviado para fila de processamento', result)
      verifyJobProgress(result);
      console.log('Gerando Relatório de Visitas - iniciando SetInterval');
    })
      .catch(function(error) {
        if (error.data) {
          MessagesService.alert(error.data);
        } else {
          error();
        }
      })
      .finally(function() {
        console.log('Gerando Relatório de Visitas - enviado para fila de processamento');
      });
  };

  function initVariables() {
    $scope.configInicial = {
      incluirAssinaturas: true,
      incluirRecomendacoes: true,
      incluirProximaVisita: true
    };

    $scope.atividades = {
      dados: [],
      loading: false
    };

    $scope.url = null;
    $scope.relatorioId = $routeParams.id;

    $scope.glebas = ($rootScope.currentPropriedade.glebas || []).map(function(gleba) {
      const result = {
        id: gleba.id,
        descricao: gleba.descricao,
        dia: new Date(),
        dados: [],
        dadosDescartados: [],
        afericoes: []
      };

      $scope.mainSortableOptions[gleba.id] = generateMainSortable(gleba);
      $scope.discardedSortableOptions[gleba.id] = generateDiscardedSortable(gleba);

      return result;
    });
  }

  const init = function() {
    LoadingService.showLoading();

    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.relatorioVisita.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      initVariables();
      OperacoesService.datas({ tipo: String(tiposPermitidos) }).then(function(datas) {
        $scope.datas = datas;
      }, error)
        .finally(function() {
          if ($scope.relatorioId) {
            $scope.goToReportById($scope.relatorioId);
          } else {
            LoadingService.hideLoading();
          }
        });
    });
  };

  const getDayClass = function(obj, datas) {
    if (obj.mode !== 'day') {
      return '';
    }

    const dateToCheck = moment(obj.date);
    for (let i = (datas || []).length - 1; i >= 0; i--) {
      if (dateToCheck.isSame(datas[i], 'day')) {
        return 'event-date';
      }
    }
  };

  $scope.glebasDayClass = function(obj) {
    return getDayClass(obj, $scope.datasGlebas);
  };

  $scope.dayClass = function(obj) {
    return getDayClass(obj, $scope.datas);
  };

  $scope.datePickerOptionsGeral = {
    showWeeks: false,
    formatDayTitle: 'dd/MM/yyyy',
    customClass: $scope.dayClass
  };

  $scope.datePickerOptions = {
    showWeeks: false,
    formatDayTitle: 'dd/MM/yyyy',
    customClass: $scope.glebasDayClass
  };

  $scope.listUsers = function() {
    $scope.loading = true;
    const params = {
      tipo: String(tiposPermitidos),
      data:  moment($scope.filters.data).toDate(),
    };

    OperacoesService.usuarios(params).then(function(usuarios) {
      $scope.filters.usuarios = [];
      $scope.usuarios = usuarios;
    }, error)
      .finally(function() {
        if ($scope.relatorioId) {
          $scope.goToReportById($scope.relatorioId);
        } else {
          $scope.loading = false;
        }
      });
  }

  $scope.goToReportById = function(id) {
    RelatorioVisitaService.get(id).then(function(result) {
      const relatorio = result.data;
      const payload = relatorio.payload;

      initVariables();

      $scope.configInicial = payload.configInicialForRestore;
      $scope.recomendacoes = payload.recomendacoesForRestore;
      $scope.glebas = payload.glebasForRestore;
      $scope.atividades = payload.atividadesForRestore;

      $scope.configInicial.dataProximaVisita = $scope.configInicial.dataProximaVisita ? moment(payload.data_proxima_visita).toDate() : null;
      $scope.configInicial.incluirProximaVisita = !!$scope.configInicial.dataProximaVisita;

      // Ajustar dados
      $scope.glebas.forEach(function(gleba) {
        gleba.dados = gleba.dados || [];
        gleba.dadosDescartados = gleba.dadosDescartados || [];
        gleba.dados.forEach(function(dado) {
          dado.imagens = dado.imagens || [];
        });
      });

      LoadingService.hideLoading();
    })
      .catch(function(error) {
        if (CommonHTTPService.isNotFound(error.status)) {
          MessagesService.alert('Não foi encontrado relatório com o código informado.');
          $scope.goToReport();
        } else {
          $rootScope.errorRootInitialize(error);
        }
      });
  };

  $scope.checkExistsAndGoToReport = function() {
    const usuarios = $scope.filters.usuarios.map(usuario => (usuario|| {}).id).join(',');
    const params = {
      data: $scope.filters.data,
      usuario: usuarios,
    }

    LoadingService.showLoading();
    RelatorioVisitaService.list(params).then(function(result) {
      const relatorios = result.data;
      if (relatorios.length === 1) {
        const buttons = {
          cancel: { label: 'Gerar novo relatório' },
          confirm: { label: 'Recuperar relatório' }
        };
        MessagesService.confirm('Já existe um relatório gerado para a data. O que deseja fazer?', buttons).then(function() {
          $location.path(`/relatoriovisitacustomizado/${relatorios[0].id}`);
        })
          .catch(function() {
            $scope.goToReport($scope.filters);
          });
      } else {
        $scope.goToReport($scope.filters);
      }
    })
      .catch(error);
  };

  $scope.goToReport = function(filter) {
    $scope.glebas.forEach(function(gleba) {
      gleba.dia = filter.data;
      $scope.getGlebaDia(gleba, true);

      $scope.configInicial.data = filter.data;
      $scope.configInicial.usuarios = $scope.filters.usuarios.map(usuario => (usuario|| {}).id).join(',');
      $scope.configInicial.dataProximaVisita = moment(filter.data).add(7, 'days')
        .toDate();
      $scope.configInicial.dataRecomendacao = filter.data;
    });

    LoadingService.hideLoading();

    return $scope.getRecomendacoesDia();
  };

  $scope.getAtividades = function() {
    if ($scope.atividades.loading) {
      return;
    }

    $scope.atividades.dados = [];

    if ($scope.configInicial.quebrarAtividade) {
      $scope.atividades.loading = true;
      const filters = {
        tipo: String(tiposPermitidos),
        data: $scope.configInicial.data
      };

      HistoricosService.listCulturas(filters).then(function(data) {
        $scope.atividades.dados = (data.data || []).reduce(function(result, atividade) {
          result[atividade.id] = atividade;
          return result;
        }, {});
      }, error)
        .finally(function() {
          $scope.atividades.loading = false;
        });
    }
  };

  $scope.isReady = function() {
    return ($scope.glebas || []).every(function(gleba) {
      return !gleba.loading && gleba.dia;
    }) && ($scope.glebas || []).length > 0;
  };

  $scope.addSummary = function(type, gleba, resumo_por_cultivar) {
    LoadingService.showLoading();
    const copy = angular.copy($scope.defaultItem);
    let promise;

    if (type === 'ocorrencias') {
      $scope.resumo_por_cultivar = resumo_por_cultivar;
      if($scope.statusInfestationMaps === 'loading') {
        LoadingService.hideLoading();
        return MessagesService.alert('Os mapas de infestação estão sendo gerados. Por favor aguarde a finalização do processo');
      }
      promise = getResumoOcorrencias(gleba, resumo_por_cultivar);
    }

    if (type === 'medias_afericoes') {
      copy.tipo = type;
      promise = getResumoAfericoes(gleba);
    }

    promise.then(function(data) {
      if (data) {
        copy.conteudo = data;
        const dados_concat = type === 'medias_afericoes' ? gleba.afericoes : gleba.dados.concat(gleba.dadosDescartados)
        copy.imagens = _.uniqBy(dados_concat.reduce(function(group, dado) {
          if (dado.tipo !== 'customizado') {
            return group.concat((dado.imagens || []).map(function(imagem) {
              return angular.copy(imagem);
            }));
          }
          return group;
        }, []), 'url');

        gleba.dados.unshift(copy);

        if (type === 'ocorrencias') {
          MessagesService.confirm('Deseja remover os dados de ocorrência e manter somente este resumo para o talhão?').then(() => {
            const itensOcorrencias = gleba.dados.filter((item) => TIPOS_OPERACAO_OCORRENCIAS.includes(item.tipo));
            itensOcorrencias.forEach((item) => $scope.discard(gleba, item));
          });
        }
      } else {
        MessagesService.alert(`Não há resumo para o talhão ${ gleba.descricao } na data ${ moment(gleba.dia).format('DD/MM') }.`);
      }
      LoadingService.hideLoading();
    }).catch(function(error) {
      MessagesService.alert('Erro ao carregar resumo');
      console.error(error);
      LoadingService.hideLoading();
    });
  };

  function getHTMLMapas(data) {
    const imagens = OperacoesDadosService.getImagesObject(data.mapas.map((item) => item.imagem));
    let html = `
      <div style="page-break-inside: avoid">
      <h2><b>Mapas</b></h2>
      <table style="width: 100%">
    `;

    // Gera tabela com duas colunas
    imagens.forEach((imagem, index) => {
      if (index === 0) {
        html += '<tr>';
      }
      if (index !== 0 && index % 2 === 0) {
        html += '</tr><tr>';
      }

      html += `<td style="text-align: center; padding: 5px;">
        <p>${(data.mapas[index] ||{}).descricao}</p>
        <img src="${imagem.report}" style="max-width: 100%">
      </td>`;
    });

    if (imagens.length % 2 === 0) {
      html += '</tr>';
    }
    html += '</table></div>';

    return html;
  }

  function errorGettingMaps(err) {
    console.error(err);
    MessagesService.alert('Não foi possível buscar a lista de Mapas.');
    $scope.statusInfestationMaps = 'untouched';
  }

  $scope.generateInfestationMaps = function() {
    $scope.statusInfestationMaps = 'loading';
    MapasInfestacaoService.generate({
      startDate: $scope.configInicial.data,
      endDate: $scope.configInicial.data
    })
      .then(function() {
        $scope.statusInfestationMaps = 'success';
      })
      .catch(errorGettingMaps);
  }

  function getResumoOcorrencias(gleba, resumo_por_cultivar) {
    return ResumoOcorrenciasIndicadoresService.getSummary({
      gleba: gleba.id,
      resumo_por_cultivar: resumo_por_cultivar,
      data: moment(gleba.dia).format(MOMENT_DATE_ENGLISH_FORMAT),
    }).then(function(result) {
      gleba.dados = gleba.dados.filter((dado) => dado.tipo !== 'customizado');

      if((result || []).length && resumo_por_cultivar) {
        return $q.resolve(result.map((data) => compile(data)))
      } else {
        return $q.resolve((result.ocorrencias || []).length ? compile(result) : false);
      }
    });

    function compile(data) {
      const template = angular.element(document.getElementById('summaryTable.html')).html();
      let result;
      const titulo = `<h2 class="text-center"><b>Resumo de Ocorrências</b> / ${data.quantidade_pontos} ponto(s)</h2>`;
      if($scope.resumo_por_cultivar) {
        const cultura_and_cultivar = data.cultivares[0].cultura.descricao + ' ' + data.cultivares[0].cultivar.descricao
        result = `<div class="cultivar-resumo">
              ${titulo}
              <br>
              <p class="text-center"> <b>${cultura_and_cultivar}</b> </p>
              `;
      } else {
        result = titulo
      }
      

      if (data.ocorrencias.length) {
        data.ocorrencias.forEach(function(ocorrencia) {
          result += $interpolate(template)(ocorrencia);
          let body = '';
          ocorrencia.indicadores.forEach(function(indicador) {
            if ((indicador.tipo === 'percentual' || indicador.tipo === 'contagem_plantas') && !(indicador.summarize || {}).percentual) {
              return;
            }
            indicador = {...indicador, pontos_totais: data.quantidade_pontos}
            const bodyTemplate = angular.element(document.getElementById(`summaryTable-${indicador.tipo}.html`)).html();
            let interpolated = $interpolate(bodyTemplate)(indicador);
            if (indicador.tipo === 'texto') {
              const textTemplate = angular.element(document.getElementById('summaryTable-texto-text.html')).html();
              let add = '';
              indicador.summarize.forEach(function(sum) {
                add += $interpolate(textTemplate)(sum);
              });
              interpolated = interpolated.replace(/%text%/, add);
            }
            body += interpolated;
          });
          result = result.replace(/%body%/, body);
        });
      }

      if($scope.resumo_por_cultivar) {
        result = `${result}</div>`
      }

      let htmlMapas = '';
      if (data.mapas.length) {
        htmlMapas = getHTMLMapas(data);
      }

      let compiledHtml = [
        result,
        htmlMapas
      ].join('');

      compiledHtml = `<div style="border: 1px solid #ccc;
            border-radius: 8px;
            padding: 8px;
            margin-bottom: 16px;
            background-color: #f9f9f9;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05)">${compiledHtml}</div>`

      return compiledHtml
    }
  }

  function getResumoAfericoes(gleba) {
    const queryParams = {
      gleba: gleba,
      dia: $scope.configInicial.data
    };

    return $q.all([
      SemeaduraAfericaoService.summarized(queryParams).then(function(results) {
        return $q.resolve((results.data || []).length ? compile(results.data, 'Semeadura') : '');
      }),

      ColheitaAfericaoService.summarized(queryParams).then(function(result) {
        return $q.resolve((result.data || []).length ? compile(result.data, 'Colheita') : '')
      })
    ]).then(results => results.join(''));

    function compile(data, type) {
      let title = `<h2 class="text-center"><b>Médias de Aferições de ${type}</b></h2>`;

      const showTotaisCana = !!data.filter((data) => {
        const obj = data.totais_cana || {};
        return !!obj.total_gemas || !!obj.total_viaveis || !!obj.total_nao_viaveis
      }).length;

      const head = `
        <tr>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Máquina</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Medida</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Pontos</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Máxima</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Minima</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Média</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Data Inicial</th>
          <th rowspan="{{ show_totais_gemas ? 2 : 1 }}">Data Final</th>
      `;

      const canaHead = `
          <th colspan="3">Gemas</th>
        </tr>
        <tr>
          <th>Total</th>
          <th>Total Viáveis</th>
          <th>Total Não Viáveis</th>
        </tr>
      `;
      
      let template = title + angular.element(document.getElementById(`summaryTableAfericoes-${type}.html`)).html()
      template = template.replace(/%head%/, head + (showTotaisCana ? canaHead : '</tr>'));
      
      let result = $interpolate(template)({ show_totais_gemas: showTotaisCana });
      if (data.length) {
        let body = '';

        const totaisCana = `
          <td>{{objeto.totais_cana.total_gemas}}</td>
          <td>{{objeto.totais_cana.total_viaveis}}</td>
          <td>{{objeto.totais_cana.total_nao_viaveis}}</td>
        `;

        data.forEach(afericao => {
          let bodyTemplate = angular.element(document.getElementById(`summaryTableAfericoes-afericao-${type}.html`)).html();
          bodyTemplate = bodyTemplate.replace(/%totais_cana%/, showTotaisCana ? totaisCana : '');

          let interpolated = $interpolate(bodyTemplate)(afericao);
          body += interpolated;
        });

        result = result.replace(/%body%/, body);
      }

      return result;
    }
  }

  $scope.rotateImage = function(image, direction) {
    image.processing = true;
    RotateImageService.rotate(image, direction).then(function(result) {
      image = result;
    }, function(error) {
      console.error('Erro ao rotacionar imagem', error);
      image.processing = false;
      MessagesService.alert('Ocorreu um erro ao girar a imagem, por favor tente novamente.');
    });
  };

  $scope.editImage = function(imagem) {
    const modal = $uibModal.open({
      controller: 'RelatorioVisitaCustomizadoEditImageCtrl',
      controllerAs: 'eImg',
      resolve: {
        image: imagem
      },
      templateUrl: 'views/relatorio_visita_customizado/templates/_edit_img_modal.html',
      windowClass: 'relatorio-edit-image-modal',
      backdrop: false
    });
    modal.result.then(function(newImage) {
      imagem.editedURL = newImage;
    }).catch(function(reason) {
      if (reason === 'reset') {
        imagem.editedURL = null;
        $scope.editImage(imagem);
      }
    });
  };

  $scope.reset = function() {
    MessagesService.confirm('Todas as modificações serão desfeitas. Você tem certeza?').then(function() {
      $scope.glebas.forEach(function(gleba) {
        gleba.dados = gleba.dadosDescartados = [];
      });
      $scope.recomendacoes = [];
      $scope.goToReport($scope.configInicial.data);
    })
      .catch(function() {});
  };

  $scope.discard = function(gleba, item) {
    const index = gleba.dados.indexOf(item);
    gleba.dadosDescartados.push(item);
    gleba.dados.splice(index, 1);
  };

  $scope.restore = function(gleba, item) {
    const index = gleba.dadosDescartados.indexOf(item);
    gleba.dados.push(item);
    gleba.dadosDescartados.splice(index, 1);
  };

  $scope.$watch('filters.data', function(newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.listUsers();
    }
  }, true);

  $scope.fileNameChanged = function() {
    const MAX_KBYTES_UPLOAD = 1024;
    const reader = new FileReader();
    reader.readAsDataURL($scope.configInicial.logotipo);
    reader.onload = function(event) {
      const sizeKb = event.total / 1024;
      if (sizeKb > MAX_KBYTES_UPLOAD) {
        MessagesService.alert(`Arquivo muito grande! O arquivo pode ter no máximo ${ MAX_KBYTES_UPLOAD / 1024 }MB`);
      } else {
        $scope.configInicial.logotipo = reader.result;
        $scope.$apply();
      }
    };
  };

  init();
});
